import { store, setScheduleData } from '../store';
import { setSchedule } from './schedule';
import { functions } from "./firebase"
import { httpsCallable } from "firebase/functions";


/**
 * Processes the schedule file stored in the application store.
 * If a file exists, it converts the file to a Base64 string and sends it to the cloud function.
 */
export function processScheduleFile(uid) {
    const file = store.scheduleFile; // Retrieve the schedule file from the store
    if (file) {
        // Convert file to Base64 and then send it to the Cloud Function
        convertFileToBase64(file, (base64String) => {
            callAddScheduleParserFunction(base64String, uid);
        });
    }
}



/**
 * Converts a file to a Base64 string.
 * @param {File} file - The file to be converted.
 * @param {function} callback - Callback function to handle the Base64 string.
 */
function convertFileToBase64(file, callback) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
        // Extract Base64 encoded string from the FileReader result
        const base64String = reader.result
            .replace('data:', '') // Remove the data prefix
            .replace(/^.+,/, ''); // Remove the Base64 prefix
        callback(base64String);
    };
    reader.onerror = (error) => {
        console.error('Error converting file to Base64:', error);
    };
}



/**
 * Calls the addScheduleParser Cloud Function with the Base64 string of the file.
 * @param {string} base64String - Base64 encoded string of the file.
 */
function callAddScheduleParserFunction(base64String, uid) {
    const addScheduleParser = httpsCallable(functions, 'func_add_schedule');

    addScheduleParser({ file: base64String })
    .then((result) => {
        // Process the result received from the Cloud Function
        const data = result.data;
        console.log('Success:', data);
        setSchedule(data, store.date, uid);
        setScheduleData(data);
    })
    .catch((error) => {
        // Handle errors encountered during the Cloud Function call
        const code = error.code;
        const message = error.message;
        const details = error.details;
        console.error('Error:', message);
    });
}
